import { __extends } from "tslib";
import React from 'react';
import { AppMode } from '../../../constants/app-mode';
import styles from './ChatWidget.scss';
import classNames from 'classnames';
import _get from 'lodash/get';
import Header from '../Header/Header';
import { expandCollapseManager } from '../../..';
import withSounds from '../../../providers/withSounds/withSounds';
import ThemeProvider from '../../../providers/theme/ThemeProvider';
var ChatWidget = /** @class */ (function (_super) {
    __extends(ChatWidget, _super);
    function ChatWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleExpand = function () {
            _this.setState({ shouldApplyExpandAnimation: true });
        };
        _this.handleCollapse = function () {
            var isMobile = _this.props.isMobile;
            !isMobile &&
                _this.setState({
                    shouldApplyCollapseAnimation: true,
                    shouldFoldHeader: true,
                });
        };
        _this.toggleHeaderFolded = function () {
            return _this.state.shouldFoldHeader ? _this.unfoldHeader() : _this.foldHeader();
        };
        _this.foldHeader = function () {
            _this.setState({
                shouldFoldHeader: true,
            });
        };
        _this.unfoldHeader = function () {
            return _this.props.unfoldable && _this.setState({ shouldFoldHeader: false });
        };
        _this.isChatRoomVisible = function () { return _this.props.available && _this.props.isExpanded; };
        _this.isCollapsedToRounded = function () {
            return _get(_this.props.theme, 'header.collapsedAsRounded', false);
        };
        _this.isCollapsedAndRounded = function () {
            return !_this.props.isExpanded && _this.isCollapsedToRounded();
        };
        _this.rootClasses = function () {
            var _a;
            var _b = _this.props, isExpanded = _b.isExpanded, available = _b.available, isMobile = _b.isMobile, isResponsive = _b.isResponsive;
            var _c = _this.state, shouldApplyExpandAnimation = _c.shouldApplyExpandAnimation, shouldApplyCollapseAnimation = _c.shouldApplyCollapseAnimation;
            return classNames((_a = {},
                _a[styles.root] = true,
                _a[styles.isMobile] = isMobile,
                _a[styles.notAvailable] = !available,
                _a[styles.expanded] = isExpanded,
                _a[styles.shouldApplyExpandAnimation] = shouldApplyExpandAnimation,
                _a[styles.shouldApplyCollapseAnimation] = shouldApplyCollapseAnimation,
                _a[styles.collapsedToRounded] = _this.isCollapsedToRounded(),
                _a[styles.isResponsive] = isResponsive,
                _a.mobileWidget = isMobile,
                _a.desktopWidget = !isMobile,
                _a.widget = true,
                _a));
        };
        _this.widgetInlineStyle = function () {
            var _a = _this.props, isMobile = _a.isMobile, theme = _a.theme;
            if (_this.isCollapsedAndRounded() || isMobile) {
                return;
            }
            return {
                borderTopLeftRadius: _get(theme, 'widget.borderRadius'),
                borderTopRightRadius: _get(theme, 'widget.borderRadius'),
            };
        };
        var initiallyApplyExpandAnimation = props.initiallyApplyExpandAnimation;
        _this.state = {
            shouldApplyExpandAnimation: !!initiallyApplyExpandAnimation,
            shouldApplyCollapseAnimation: false,
            shouldFoldHeader: true,
        };
        return _this;
    }
    ChatWidget.prototype.componentDidMount = function () {
        expandCollapseManager.registerOnCollapse(this.handleCollapse);
        expandCollapseManager.registerOnExpand(this.handleExpand);
        this.onChatDisplayed();
    };
    ChatWidget.prototype.componentWillUnmount = function () {
        expandCollapseManager.unregisterOnExpand(this.handleExpand);
        expandCollapseManager.unregisterOnCollapse(this.handleCollapse);
    };
    ChatWidget.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (!nextProps.unfoldable && this.props.unfoldable) {
            this.foldHeader();
        }
    };
    ChatWidget.prototype.onChatDisplayed = function () {
        this.props.eventHooks.onChatDisplayed &&
            this.props.eventHooks.onChatDisplayed();
    };
    ChatWidget.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.state, shouldFoldHeader = _b.shouldFoldHeader, shouldApplyExpandAnimation = _b.shouldApplyExpandAnimation, shouldApplyCollapseAnimation = _b.shouldApplyCollapseAnimation;
        var _c = this.props, isExpanded = _c.isExpanded, onlineTitle = _c.onlineTitle, onlineMessage = _c.onlineMessage, avatar = _c.avatar, isMobile = _c.isMobile, eventHooks = _c.eventHooks, locale = _c.locale, onClickBack = _c.onClickBack, availabilityStatus = _c.availabilityStatus, onCancel = _c.onCancel, unfoldable = _c.unfoldable, theme = _c.theme, unreadCount = _c.unreadCount, onProfileClick = _c.onProfileClick, hideCollapseButton = _c.hideCollapseButton, menu = _c.menu, typicallyReplies = _c.typicallyReplies, isResponsive = _c.isResponsive;
        var isThereQAB = isMobile && !isResponsive;
        var shouldShowBadge = !isExpanded && !isThereQAB && unreadCount && unreadCount > 0;
        var badgeClassNames = classNames((_a = {},
            _a[styles.unreadBadge] = true,
            _a[styles.unreadBadgeRounded] = this.isCollapsedAndRounded(),
            _a[styles.mobileResponsive] = isResponsive && isMobile,
            _a));
        var badgeElement = shouldShowBadge ? (React.createElement("div", { "data-hook": "new-message-badge", className: badgeClassNames },
            React.createElement("span", { "data-hook": "new-message-badge-count", className: styles.counter }, unreadCount))) : null;
        return (React.createElement("div", null,
            badgeElement,
            React.createElement(ThemeProvider, { theme: theme },
                React.createElement("div", { "data-hook": "chat-widget", className: "" + this.rootClasses(), style: this.widgetInlineStyle() },
                    React.createElement(Header, { clickable: unfoldable || !isExpanded, isHeaderFolded: shouldFoldHeader, onProfileClick: onProfileClick, shouldApplyFoldAnimation: true, shouldApplyUnfoldAnimation: true, toggleHeaderFolded: this.toggleHeaderFolded, shouldApplyExpandAnimation: !isMobile && shouldApplyExpandAnimation, shouldApplyCollapseAnimation: !isMobile && shouldApplyCollapseAnimation, isExpanded: isExpanded, hideCollapseButton: hideCollapseButton, onClickBack: onClickBack, onCancel: onCancel, onlineTitle: onlineTitle, onlineMessage: onlineMessage, avatar: avatar, isMobile: isMobile, availabilityStatus: availabilityStatus, locale: locale, menu: menu, typicallyReplies: typicallyReplies }),
                    React.Children.map(this.props.children, function (child) {
                        return React.isValidElement(child)
                            ? React.cloneElement(child, {
                                foldHeader: _this.foldHeader,
                                unfoldHeader: _this.unfoldHeader,
                                isHeaderFolded: shouldFoldHeader,
                                appMode: AppMode.Widget,
                                isVisible: _this.isChatRoomVisible(),
                                isCollapsedAndRounded: _this.isCollapsedAndRounded(),
                                shouldApplyExpandAnimation: !isMobile && shouldApplyExpandAnimation,
                                shouldApplyCollapseAnimation: !isMobile && shouldApplyCollapseAnimation,
                                isMobile: isMobile,
                                eventHooks: eventHooks,
                                locale: locale,
                                isExpanded: isExpanded,
                            })
                            : child;
                    })))));
    };
    ChatWidget.defaultProps = {
        eventHooks: {},
        available: true,
        isMobile: false,
        unfoldable: true,
        initiallyApplyExpandAnimation: true,
    };
    ChatWidget.isActive = function (self) {
        return self && !document.hidden && self.props.isExpanded;
    };
    return ChatWidget;
}(React.Component));
export default withSounds({
    isChatActivePredicate: ChatWidget.isActive,
})(ChatWidget);
//# sourceMappingURL=ChatWidget.js.map